import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=f94afae8&scoped=true"
import script from "./accountSetting.vue?vue&type=script&lang=js"
export * from "./accountSetting.vue?vue&type=script&lang=js"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=f94afae8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94afae8",
  null
  
)

export default component.exports